import sdk from "@repo/api-sdk";
import { queryOptions, useQuery } from "@tanstack/react-query";

const PAYMENT_PROVIDERS_KEY = "payment-providers" as const;

export const paymentQueryKeys = {
  all: [PAYMENT_PROVIDERS_KEY] as const,
  list: (regionId: string) => [PAYMENT_PROVIDERS_KEY, "list", regionId] as const
};

/**
 * Query options for fetching payment providers available in a region.
 */
export function paymentProvidersQuery(regionId: string) {
  return queryOptions({
    queryKey: paymentQueryKeys.list(regionId),
    queryFn: () =>
      sdk.store.payment.listPaymentProviders({ region_id: regionId }),
    enabled: !!regionId,
    staleTime: 5 * 60 * 1000 // 5 minutes — providers rarely change
  });
}

/**
 * Fetches payment providers available for a given region.
 *
 * @example
 * ```tsx
 * const { data, isLoading } = usePaymentProviders(regionId);
 * data?.payment_providers.map(p => p.id);
 * ```
 */
export function usePaymentProviders(
  regionId: string,
  options?: { enabled?: boolean }
) {
  return useQuery({
    ...paymentProvidersQuery(regionId),
    enabled: !!regionId && (options?.enabled ?? true)
  });
}
